// extracted by css-extract-rspack-plugin
export default {"container":"container-n7ANxK"};